export const TypewriterStrings = ['Full Stack Developer', 'Software Engineer'];
